(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-version-page', {
            parent: 'entity',
            url: '/document-version-page',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentVersionPage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-version-page/document-version-pages.html',
                    controller: 'DocumentVersionPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentVersionPage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-version-page-detail', {
            parent: 'entity',
            url: '/document-version-page/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentVersionPage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-version-page/document-version-page-detail.html',
                    controller: 'DocumentVersionPageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentVersionPage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentVersionPage', function($stateParams, DocumentVersionPage) {
                    return DocumentVersionPage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-version-page',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-version-page-detail.edit', {
            parent: 'document-version-page-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version-page/document-version-page-dialog.html',
                    controller: 'DocumentVersionPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentVersionPage', function(DocumentVersionPage) {
                            return DocumentVersionPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-version-page.new', {
            parent: 'document-version-page',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version-page/document-version-page-dialog.html',
                    controller: 'DocumentVersionPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                pageNo: null,
                                fileRef: null,
                                data: null,
                                dataContentType: null,
                                imageHeight: null,
                                imageWidth: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-version-page', null, { reload: 'document-version-page' });
                }, function() {
                    $state.go('document-version-page');
                });
            }]
        })
        .state('document-version-page.edit', {
            parent: 'document-version-page',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version-page/document-version-page-dialog.html',
                    controller: 'DocumentVersionPageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentVersionPage', function(DocumentVersionPage) {
                            return DocumentVersionPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-version-page', null, { reload: 'document-version-page' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-version-page.delete', {
            parent: 'document-version-page',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-version-page/document-version-page-delete-dialog.html',
                    controller: 'DocumentVersionPageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentVersionPage', function(DocumentVersionPage) {
                            return DocumentVersionPage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-version-page', null, { reload: 'document-version-page' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
